import { createApp } from 'vue';
import App from './components/App.vue';
import router from './router';
import store from './store';
import sileo from 'sileo';
import plex from 'core/js/restmodel';
import VueTour from 'vue3-tour';
import 'vue3-tour/dist/vue3-tour.css';

import './stylesheets/sass/styles.scss';
import Zenerics from '@bposeats/zenerics';
import '@bposeats/zenerics/sass/style.scss';
import '@bposeats/zenerics/sass/base/icons.scss';

import axios from './lib/axios';
import eventBus from './lib/event-bus';
import EventBusCallbacks from './plugins/event-bus-callbacks';
import { initMilestoneChatSeenChannel } from './lib/milestoneChatSeenChannel';
import idb from 'idb';

// MDI font deferred loading for better LCP - loads after initial paint
// import '@mdi/font/css/materialdesignicons.css';
import VueCarousel from 'vue-carousel';

// Defer MDI font loading until after page load
if (typeof window !== 'undefined') {
    window.addEventListener('load', () => {
        import('@mdi/font/css/materialdesignicons.css');
    }, { once: true });
}



sileo.defaults.baseUrl = process.env.API_URL; // Injected via webpack.DefinePlugin
plex.defaults.baseUrl = process.env.API_URL; // Injected via webpack.DefinePlugin
/* eslint-disable */

plex.defaults.headers['X-Requested-With'] = 'XMLHttpRequest';

const domain = 'hqzen.com';
const platform = 'web'

axios.defaults.headers.common['X-Domain'] = domain;
axios.defaults.headers.common['X-Platform'] = platform;

sileo.defaults.headers['X-Domain'] = domain;
sileo.defaults.headers['X-Platform'] = platform;

plex.defaults.headers['X-Domain'] = domain;
plex.defaults.headers['X-Platform'] = platform;

const app = createApp(App);

// TODO: Implement auth in vuex
const onTokenExpire = (response) => {
    if (response.error == 'token') {
        const forceLogout = true
        store.dispatch('auth/performLogout', forceLogout);
    }
};

const redirectToErrorPage = (responseText,response) => {
    if(response.status === 404){
        router.replace({ name: 'page-not-found'})
    } else if (response.status === 403){
        if (localStorage.getItem('auth_token')) {
            router.replace({ name: 'access-denied'})
        } else {
            router.replace({ name: 'signin'})
        }
    };
};

// TODO: Will we need feature switches

sileo.defaults.interceptors.push(onTokenExpire);
plex.defaults.interceptors.push(onTokenExpire);
sileo.defaults.interceptors.push(redirectToErrorPage);

// TODO: Implement auth in vuex
if (localStorage.getItem('auth_token')) {
    axios.defaults.headers.common['Authorization'] = localStorage.getItem('auth_token');
    axios.defaults.headers.common['X-Refresh-Token'] = localStorage.getItem('refresh_token');
}

if (localStorage.getItem('auth_token')) {
    sileo.defaults.headers['Authorization'] = localStorage.getItem('auth_token');
    sileo.defaults.headers['X-Refresh-Token'] = localStorage.getItem('refresh_token');
}

// This is a user type being used to determine a users role. When we refactor
// our back-end to not use this anymore, then remove this.
const APPLICANT = 1;

router.beforeEach(async (to, from, next) => {
    if (!store.getters['auth/user'] && !store.getters['auth/token'] && to.name != 'redirect') {
        await store.dispatch('auth/getCurrentUser');
    }

    const user = store.getters['auth/user'];
    const boards = store.getters['board/boardsByWorkforce']

    const toInternalRoute = to.matched.some(r => r.name === 'internal');
    const toJobsPortal = to.matched.some(r => r.name === 'jobs-board');

    if (toInternalRoute && !user) {
        return next({replace: true, name: 'signin'});
    } else {
        await store.dispatch('generics/initiateWebsocketConnection');
    }

    // Refactor this later
    if (toJobsPortal && !user) {
        const loginToJobs = {
            name: 'signin',
            query: {
                to: to.fullPath
            }
        };
        return next(loginToJobs);
    }

    if (toInternalRoute && user) {
        const isBlocked = user.user_profile?.employment?.is_blocked;

        if (isBlocked) {
            return next({ replace: true, name: 'access-denied' });
        }
    }

    if (to.name === 'hqzen-signin' && user) {
        return next({ name: 'board-page' });
    }

    if (user) {
        if(user.user_profile.is_workforce_exec &&
            !user.user_profile.is_fully_verified &&
            user.user_profile.signup_source_display === 'Business Signup') {
            if(to.name != 'administrator-account-info' && !to.path.includes('help-center')){
                if(from.name != 'administrator-account-info' && !from.path.includes('help-center')){
                    const canNotAccess = true;
                    eventBus.$emit('access-denied-event', canNotAccess);
                }else{
                    if(to.name != 'board-main') {
                        let boardParams = {
                            company_id: user.user_profile.company.pk,
                            workforce_id: user.user_profile.workforce_ids[0],
                            board_id: boards[user.user_profile.workforce_ids[0]][0].pk
                        }
                        return next ({ name: 'board-main', params: boardParams })
                    }
                }
            }
        }
    }

    return next();
});


router.onError((error, to) => {
    if (
        error.message.includes('Failed to fetch dynamically imported module') ||
        error.message.includes('Importing a module script failed')
    ) {
        if (!to?.fullPath) {
            window.location.reload();
        } else {
            window.location = to.fullPath;
        }
    }
});

(() => {
    window.addEventListener('storage', (event) => {
        if (event.storageArea !== localStorage) {
            return;
        }
        if (event.key === 'auth_token') {
            router.go()
        }
    });
})();

window.__ENV__ = process.env.NODE_ENV || 'development';

/**
 * This disables the console.log and console.error in the production environment
*/
if (process.env.BRANCH_ENV === 'master' && process.env.HIDE_LOGS){
    console.log = function() {}
    console.error = function() {}
}

/**
 * Global error handler for unhandled errors outside of Vue components.
 *
 * @param {string} message - The error message.
 * @param {string} source - The URL of the script where the error occurred.
 * @param {number} lineNo - The line number where the error occurred.
 * @param {number} columnNo - The column number where the error occurred.
 * @param {Error} error - The error object.
 * @returns {void}
 */
window.onerror = function (message, source, lineNo, columnNo, error) {
        console.log('General JS',error);
    // TODO: send error report to server
  };

/**
 * @typedef {Object} ErrorObject
 * @property {string} message - The error message.
 * @property {string} stack - The error stack trace.
 */

/**
 * Global error handler for the Vue app.
 *
 * @param {Error} err - The error object.
 * @param {Vue} vm - The Vue instance where the error occurred.
 * @param {string} info - Additional error information.
 * @returns {void}
 */
app.config.errorHandler = function (error, vm, info) {
        console.log('errorHandler', error)
    // TODO: send error report to server
}

/**
 * Global warning handler for the Vue app.
 *
 * @param {string} msg - The warning message.
 * @param {Vue} vm - The Vue instance where the warning occurred.
 * @param {string} trace - The trace of the warning.
 * @returns {void}
 */
app.config.warnHandler = function (warning, vm, trace) {
        console.log({warning, trace});
  };

/**
 * Event listener to handle visibility change of the of a given tab
 */
document.addEventListener('visibilitychange', async function() {
    /**
     * Check if the tab is not hidden (gains focus).
     * Then attempt to get the current user using 'auth/getCurrentUser' action.
    */
   if (!document.hidden) {
        await store.dispatch('auth/getCurrentUser');
    }

});


/**
 * Event listener to handle focus of the window.
 * */
window.addEventListener('focus', async() => {
    /**
     * Attempt to get the current user using 'auth/getCurrentUser' action.
     * */
    await store.dispatch('auth/getCurrentUser');
});

app.config.globalProperties.$eventBus = eventBus;
app.use(Zenerics);
app.use(router);
app.use(store);
app.use(EventBusCallbacks, eventBus);
app.use(VueCarousel);
app.use(VueTour)

app.provide('$eventBus', eventBus);

// Listen for cross-tab "milestone chat read" broadcasts so unread indicators
// stay in sync across tabs without a manual refresh.
initMilestoneChatSeenChannel();

app.mixin({
    async created() {
        // Initializing indexed_db
        await idb.init().catch(e => {
            console.error(e);
        });
    },
});

app.mount('#app');


// Defer Mautic Tracking Script loading for better initial page load

window.addEventListener('load', () => {

    // Only run this if we're on production
    if (process.env.BRANCH_ENV !== 'master') {
        return
    }

    setTimeout(() => {
        (function(w,d,t,u,n,a,m){w['MauticTrackingObject']=n;
           w[n]=w[n]||function(){(w[n].q=w[n].q||[]).push(arguments)},a=d.createElement(t),
           m=d.getElementsByTagName(t)[0];a.async=1;a.src=u;m.parentNode.insertBefore(a,m)
        })(window,document,'script','https://marketing.bposeats.info/mtc.js','mt');

        // Send initial pageview after script loads
        setTimeout(() => {
            if (typeof mt === 'function') {
              mt('send', 'pageview');
            }
        }, 500);
    }, 100);
});

// Track SPA route changes
router.afterEach((to) => {
  if (typeof mt === 'function') {
    mt('send', 'pageview', { url: window.location.origin + to.fullPath });
  }
});
